<template>                    
    <form-helper> 
        <div slot="form-header">
            
            <h2>Logos</h2>                                                
            
        </div>
        <div slot="form-fields">
            <v-layout row>
                <v-flex xs4>
                    <v-card class="ma-3 pa-2">
                        <v-card-title>
                            <h5 class="grey--text"> File Upload </h5>
                        </v-card-title>
                        <v-card-media 
                            height="100px"
                            :src="logoSrc"
                            contain
                            class="my-3"
                        >                        
                        </v-card-media>

                        <v-card-actions>
                            <v-flex xs-2 offset-xs5>
                                <v-btn flat class="grey darken-3 file-btn">                             
                                    <v-icon x-large class="grey--text">backup</v-icon>                             
                                    <input type="file" v-on:change="onFileChange"/>
                                </v-btn>
                            </v-flex>
                        </v-card-actions>
                    </v-card>

                </v-flex>
                <v-flex xs6>
                    <v-container grid-list-xs>
                        <v-layout row wrap>
                            <v-flex xs6 v-for="(logo, index) in mk.logos" :key="index">
                                <v-card>

                                    <v-card-media 
                                        v-bind:src="markenlogo(logo.dateiserverpfad)"
                                        height="60px"
                                        contain
                                    >
                                    </v-card-media>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn flat class="grey darken-3" v-on:click="removeImage(index)">
                                            <v-icon class="grey--text text--lighten-1" >delete</v-icon>
                                        </v-btn>                                
                                    </v-card-actions>                                                                                                                 
                                </v-card>
                            </v-flex>                                                                   
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
        </div>
        
        <div slot="form-commands" >

            <v-btn icon v-on:click="submitted">
                <v-icon x-large class="green--text">done</v-icon>
            </v-btn>                        


            <router-link to="/marken" exact>
                <v-btn icon>
                    <v-icon x-large class="red--text">close</v-icon>
                </v-btn>
            </router-link>

        </div>
        
        
    </form-helper>



</template>
<script>
import formHelper from '../formHelper.vue'

export default {
   
    components: {
        'form-helper': formHelper,
        
    },
    data() {
        return {
            id: this.$route.params.id,  
            logoSrc:'',
            
            
        };
    },
    
    computed: {
              
        mk: function() {
            return this.$store.getters.marke
        },
        loading: function() {
            return this.$store.getters.loading
        },
        basePath: function() {
            return this.$axios.defaults.baseURL
        }, 
    },
    methods: {
        submitted: function() {
                        
            this.$emit('submitted', this.mk)
        },
        
        
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.createImage(files[0]);
        },
        createImage(file) {
            
            var reader = new FileReader();
            var data = new FormData();
            var vm = this;
            
            data.append('logo', file);
            data.append('name', this.mk.name.replace(' ', '_'))
            data.append('timestamp', new Date().getTime())
            data.append('mainfolder', this.mk.firmen[0].id);

            reader.onload = (e) => {
                this.logoSrc = e.target.result;
            };
            this.$store.dispatch('postLogo',data).then((response)=>{                 
                reader.readAsDataURL(file);            
                vm.mk.logos.push(response);
            })
            
        },
        removeImage: function (index) {
            this.mk.logos.splice(index,1);
        },
        
        markenlogo: function(path) {
            return this.basePath + 'storage/logos/' + path;
        },       
    }
}
    
</script>

<style>
    
    .file-btn {
    cursor: pointer;
    position: relative;
    overflow: hidden;
   
  }
    .file-btn input[type=file] {
    
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    cursor: inherit;
    display: block;
    
  }
    
</style>


// WEBPACK FOOTER //
// editMarken_2.vue?3fb5b412